import anzaL7_1 from "./5.png";
import anzaL7_2 from "./6.png";
import anzaL7_3 from "./7.png";

const anzahome7 = [anzaL7_1, anzaL7_2, anzaL7_3];

export default anzahome7;
